"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

var _styles = require("@material-ui/core/styles");

var _DataTransfer = _interopRequireDefault(require("fbjs/lib/DataTransfer"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    field: {
      width: theme.spacing(6),
      height: theme.spacing(6),
      "& .MuiInputBase-input": {
        height: 20,
        padding: 14
      },
      "& input": {
        textAlign: "center"
      },
      "& .MuiOutlinedInput-root": {
        borderRadius: 6
      }
    }
  };
});
/**
 *
 * ** Pin component is for users to add a line of numbers to verify themselves during doing a task. Suggested use is for entering a code received by SMS. Should be used with numerical keyboard. **
 *
 */

var OtpInput = function OtpInput(_ref) {
  var _ref$length = _ref.length,
      length = _ref$length === void 0 ? 4 : _ref$length,
      _ref$isPin = _ref.isPin,
      isPin = _ref$isPin === void 0 ? false : _ref$isPin,
      onChange = _ref.onChange;
  var styles = useStyles();
  var inputRefs = (0, _react.useRef)([]);

  if (inputRefs.current.length !== length) {
    inputRefs.current = Array(length).fill().map(function (el, index) {
      return inputRefs.current[index] || /*#__PURE__*/_react.default.createRef();
    });
  }

  var _useState = (0, _react.useState)(Array(length).fill({
    value: ""
  })),
      _useState2 = _slicedToArray(_useState, 2),
      otp = _useState2[0],
      setOtp = _useState2[1];

  var handlePaste = function handlePaste(evt) {
    var data = new _DataTransfer.default(evt.clipboardData);
    var text = data.getText();
    var textArray = text.split("");

    var newOtp = _toConsumableArray(otp); // eslint-disable-next-line array-callback-return


    newOtp.map(function (item, index) {
      var newOtpField = _objectSpread({}, otp[index]);

      newOtpField.value = textArray[index];
      newOtp[index] = newOtpField;
    });
    setOtp(newOtp);
    onChange(newOtp.map(function (elm) {
      return elm.value;
    }).join(""));
  };

  var pressOtp = function pressOtp(e, index) {
    var numeric = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "Backspace", "Delete"]; // const alphabetic = ["a","A","b","B","c","C","d","D","e","E","f","F","g","G","h","H","i","I","j","J","k","K","l","L","n","N","m","M"]

    if (numeric.includes(e.key)) {
      var newOtp = _toConsumableArray(otp);

      var newOtpField = _objectSpread({}, otp[index]);

      if (e.key !== "Backspace" && e.key !== "Delete") {
        newOtpField.value = e.key;

        if (index < otp.length - 1) {
          inputRefs.current[index + 1].current.focus();
        }
      } else {
        newOtpField.value = "";
      }

      newOtp[index] = newOtpField;
      setOtp(newOtp);
    }

    console.log(e.keyCode, e.key);
  };

  return /*#__PURE__*/_react.default.createElement(_core.Box, null, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 1,
    alignItems: "center",
    justify: "center",
    wrap: "nowrap"
  }, otp.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: "auto",
      key: "otp-input-".concat(index)
    }, /*#__PURE__*/_react.default.createElement(_core.TextField, {
      id: "otp-input-".concat(index),
      inputRef: inputRefs.current[index],
      inputProps: {
        maxLength: 1
      },
      value: item.value,
      color: "primary",
      variant: "outlined",
      type: isPin ? "password" : "text",
      onKeyUp: function onKeyUp(e) {
        return pressOtp(e, index);
      },
      onPaste: function onPaste(e) {
        return handlePaste(e);
      },
      className: styles.field
    }));
  })));
};

OtpInput.propTypes = {
  /** Length of the input fields */
  length: _propTypes.default.number.isRequired,

  /** Show digits or dots */
  isPin: _propTypes.default.bool,

  /** Action to call on the onChange (returns value) */
  onChange: _propTypes.default.func
};
OtpInput.defaultProps = {
  isPin: false,
  onChange: null
};
var _default = OtpInput;
exports.default = _default;